import React, { useState } from 'react';
import './HelpPage.css';

function HelpPage() {
    const [formData, setFormData] = useState({
        fullName: '',
        nrc: '',
        email: '',
        phoneNumber: '',
        problemDescription: '',
        attachment: null,
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleFileChange = (e) => {
        setFormData(prevState => ({
            ...prevState,
            attachment: e.target.files[0],
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Handle form submission logic here
        console.log(formData);
        alert('Your request has been submitted.');
    };

    return (
        <div className="help-page-container">
            <h1>Help & Support</h1>
            <p>Please fill out the form below to get assistance.</p>
            <form onSubmit={handleSubmit} className="help-form">
                <div className="form-group">
                    <label htmlFor="fullName">Full Name</label>
                    <input type="text" id="fullName" name="fullName" value={formData.fullName} onChange={handleChange} required />
                </div>
                <div className="form-group">
                    <label htmlFor="nrc">NRC</label>
                    <input type="text" id="nrc" name="nrc" value={formData.nrc} onChange={handleChange} required />
                </div>
                <div className="form-group">
                    <label htmlFor="email">Email</label>
                    <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required />
                </div>
                <div className="form-group">
                    <label htmlFor="phoneNumber">Phone Number</label>
                    <input type="tel" id="phoneNumber" name="phoneNumber" value={formData.phoneNumber} onChange={handleChange} required />
                </div>
                <div className="form-group">
                    <label htmlFor="problemDescription">Problem/Description</label>
                    <textarea id="problemDescription" name="problemDescription" value={formData.problemDescription} onChange={handleChange} rows="5" required></textarea>
                </div>
                <div className="form-group">
                    <label htmlFor="attachment">Attachment (Optional)</label>
                    <input type="file" id="attachment" name="attachment" onChange={handleFileChange} />
                </div>
                <button type="submit" className="submit-button">Submit</button>
            </form>
        </div>
    );
}

export default HelpPage;
